import { PerformanceIndicatorCalculationRange, defaults, getAPIMethod } from 'typed/api';
import { ExtractAction, entityActionSet, networkAction } from './utils';

// TODO merge actions/performanceIndicators to here

export const
    { loadAll: loadAllPerformanceIndicatorGroups } = entityActionSet(defaults.PerformanceIndicatorGroupReport, {
        loadAll: networkAction('LOAD_ALL_PERFORMANCE_INDICATOR_GROUPS', getAPIMethod('PerformanceIndicatorGroup', 'loadAll'))
    }),

    { loadAll: loadAllPerformanceIndicatorCalculationRanges } = entityActionSet(defaults.PerformanceIndicatorCalculationRange, {
        loadAll: networkAction('LOAD_ALL_PERFORMANCE_INDICATOR_CALCULATION_RANGES', getAPIMethod('PerformanceIndicatorCalculationRange', 'loadAll'))
    }),

    calculatePerformanceIndicatorData = (calculateChanged: boolean, calculationRange: PerformanceIndicatorCalculationRange) =>
        networkAction(
            'CALCULATE_PERFORMANCE_INDICATOR_DATA',
            { calculateChanged, calculationRange },
            getAPIMethod('PerformanceIndicator', 'calculateIndicatorsData'),
            calculateChanged,
            calculationRange
        );

export type IndicatorsAction = ExtractAction<
| typeof loadAllPerformanceIndicatorGroups
| typeof loadAllPerformanceIndicatorCalculationRanges
| typeof calculatePerformanceIndicatorData
>;
